import { ChangeDetectionStrategy, Component, inject, computed, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, of } from 'rxjs';
import { PresignedUrlCacheService } from '@core/services/common/presigned-url-cache.service';

@Component({
  selector: 'core-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageComponent {
  public readonly size = input('auto auto');
  public readonly dimensions = input.required<{
    width: string;
    height: string;
  }>();
  public readonly newImage = input<string>();
  public readonly borderless = input(false);
  public readonly imageId = input<string>();

  private presignedUrlCacheService = inject(PresignedUrlCacheService);

  private readonly loadedUrl = toSignal(
    toObservable(this.imageId).pipe(
      switchMap((id) => (id ? this.presignedUrlCacheService.getImageUrl(id) : of(undefined))),
    ),
  );

  public readonly displayUrl = computed(() => this.newImage() ?? this.loadedUrl());
}
